import * as z from "zod/v4";

export const getTiktokAuthorizationExpiration = {
  name: "getTiktokAuthorizationExpiration" as const,
  input: z.object({}),
  output: z.object({ refreshTokenExpiresAt: z.date().nullish() }),
};
